export const SERVICES_CONSTS = {
    GET_SERVICES: "GET_SERVICES",
    GET_SERVICE_REQUESTS: "GET_SERVICE_REQUESTS",
    DELETE_SERVICE_REQUEST_BY_ID: "DELETE_SERVICE_REQUEST_BY_ID",
    CREATE_SERVICE: "CREATE_SERVICE",
    GET_SERVICE_BY_ID: "GET_SERVICE_BY_ID",
    UPDATE_SERVICE_BY_ID: "UPDATE_SERVICE_BY_ID",
    DELETE_SERVICE_BY_ID: "DELETE_SERVICE_BY_ID",
};
